import Analytics from "../../../../helpers/analytics"

export default function (state, userId) {
  var errors = 0;

  if (
    state.advertisementMedia === "" &&
    state.digitalMedia === "" &&
    state.nonprofitMedia === "" &&
    state.tvMedia === ""
  ) {
    document.getElementById("usageError").classList.remove("hidden");
    errors++;
  } else {
    document.getElementById("usageError").classList.add("hidden");
  }

  if (state.firstName.trim() === "") {
    document.getElementById("fnError").classList.remove("hidden");
    document.getElementById("first_name").classList.add("error");
    Analytics.track("FirstNameError", {
      category: "LP-Inquiry",
      label: userId,
    });
    errors++;
  } else {
    document.getElementById("fnError").classList.add("hidden");
    document.getElementById("first_name").classList.remove("error");
  }

  if (state.lastName.trim() === "") {
    document.getElementById("lnError").classList.remove("hidden");
    document.getElementById("last_name").classList.add("error");
    Analytics.track("LastNameError", {
      category: "LP-Inquiry",
      label: userId,
    });
    errors++;
  } else {
    document.getElementById("lnError").classList.add("hidden");
    document.getElementById("last_name").classList.remove("error");
  }

  if (state.email.trim() === "") {
    document.getElementById("emailError").classList.remove("hidden");
    document.getElementById("email").classList.add("error");
    Analytics.track("emailError", {
      category: "LP-Inquiry",
      label: userId,
    });
    errors++;
  } else {
    document.getElementById("emailError").classList.add("hidden");
    document.getElementById("email").classList.remove("error");
  }

  if (state.phoneNumber.trim() === "") {
    document.getElementById("phoneError").classList.remove("hidden");
    document.getElementById("phone").classList.add("error");
    Analytics.track("PhoneNumberError", {
      category: "LP-Inquiry",
      label: userId,
    });
    errors++;
  } else {
    document.getElementById("phoneError").classList.add("hidden");
    document.getElementById("phone").classList.remove("error");
  }

  if (state.showTitleName.trim() === "") {
    document.getElementById("pjError").classList.remove("hidden");
    document
      .getElementById(process.env.REACT_APP_SALESFORCE_SHOW_ID)
      .classList.add("error");

    Analytics.track("ProjectError", {
      category: "LP-Inquiry",
      label: userId,
    });
    errors++;
  } else {
    document.getElementById("pjError").classList.add("hidden");
    document
      .getElementById(process.env.REACT_APP_SALESFORCE_SHOW_ID)
      .classList.remove("error");
  }

  if (state.companyName.trim() === "") {
    document.getElementById("wpError").classList.remove("hidden");
    document.getElementById("city").classList.add("error");
    Analytics.track("WorkError", {
      category: "LP-Inquiry",
      label: userId,
    });
    errors++;
  } else {
    document.getElementById("wpError").classList.add("hidden");
    document.getElementById("city").classList.remove("error");
  }

  if (errors > 0) {
    window.scrollTo({ top: 0 });
    Analytics.track("PlaceInquiryClickWithError(s)", {
      category: "LP-Inquiry",
      label: userId,
    });
    return false;
  } else {
    Analytics.track("InquiryPlacedSuccessfully", {
      category: "LP-Inquiry",
      label: userId,
    });
    return true;
  }
}
